import { textSize, color } from '@portal/kit/pkg/styles'

const styles = {
  confirmationItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 0 0 0',
    marginBottom: 16,
    minHeight: 30,
    ...textSize(14, 19),
  },
  confirmationItemIcon: {
    paddingRight: 10,
    fontSize: 30,
    ...color('textSuccess'),
  },
  confirmationItemIconPending: {
    ...color('disabled'),
  }
}

export default styles
